define(
  'app/views/discount_list_view',['app/setup',
    'app/views/grouped_ext_buy_button_view',
    'app/collections/discount_collection',
    'app/views/pagination__view',
  ],
  function (takhfifan) {

    takhfifan.DiscountListView = Backbone.View.extend({

      model: takhfifan.DiscountCollection,

      initialize: function (options) {
        if (options.vendorId) {
          this.vendorId = options.vendorId;
          this.collection = new takhfifan.DiscountCollection();
          this.page = 0;
          this.itemPerPage = 20;//a copy of the number exists in `discount_grouped.phtml`
          this.onlyActive = 1;
          this.pageCount = this.getPageCount(options.productCount);
          var self = this;

          this.setFill();
          this.renderFirstPageData();
          takhfifan.eventHub.on('dc:loadBrandPage', function (options) {
            self.fetchCollection(options.page);
          });
        } else {
          takhfifan.eventHub.trigger('message:show', {
            msg: i18n.t('coupon_code_read_error'),
            type: 'error'
          });
        }
      },

      setFill: function() {
        var $starsFill = $('.tkh-stars-fill');
        var rating = parseFloat($starsFill.data('rating'));
        $starsFill.width((rating * 20 - 2)+"%");
      },

      getPageCount: function (productCount) {
        var pageCount= 0;
        if (productCount != undefined && productCount != null) {
          if (productCount > 0) {
            pageCount = Math.floor(productCount / this.itemPerPage);
            if (productCount % this.itemPerPage !== 0) {
              pageCount += 1;
            }

            this.$el.parents('.tkh-dc-vendor').removeClass('loading-view');
          } else {
            this.$el.parents('.tkh-dc-vendor').removeClass('loading-view');
          }
        } else {
          takhfifan.eventHub.trigger('message:show', {
            msg: i18n.t('coupon_code_read_error'),
            type: 'error'
          });
          this.$el.parents('.tkh-dc-vendor').removeClass('loading-view');
        }
        return pageCount;
      },

      fetchCollection: function (page) {
        var self = this;
        self.$el.parents('.tkh-dc-vendor').addClass('loading-view');
        this.collection.fetch({
          reset: true,
          data: {
            vendorId: this.vendorId,
            page: page,
            limit: this.itemPerPage,
            only_active: self.onlyActive
          },
          success: function () {
            self.page = page;
            self.$el.find('.tkh-deal-item-container').remove();
            self.render()
          },
          failed: function () {
            takhfifan.eventHub.trigger('message:show', {
              msg: i18n.t('coupon_code_read_error'),
              type: 'error'
            });
            self.$el.parents('.tkh-dc-vendor').removeClass('loading-view');
          }
        });
      },

      addUpdateMetaData: function (allItemData, allDealType) {
        if($('#tkh-grouped-products-data').length !== 0){
          $('#tkh-grouped-products-data').val(JSON.stringify( allItemData));
          $('#tkh-deal-types').val( JSON.stringify(allDealType));
        }else{
          var metaTempalte = _.template($('#tkh-dc-brand-meta-data').html());
          this.$el.find('tkh-dc-brand-meta-data').remove();
          this.$el.append(metaTempalte({
            allItemsData: JSON.stringify(allItemData),
            dealTypes: JSON.stringify(allDealType)
          }));
        }
        takhfifan.eventHub.trigger('dc:deal-filter-update');
      },

      ItemDataMaker: function (model) {
        var nameCharLength = 70;
        var nameShorted = model.get('nameOriginal') > nameCharLength ?
          model.get('nameOriginal').sub_str(0, nameCharLength) + " &hellip;" : model.get('nameOriginal');

        return {
          'id': model.get('id'),
          'name': nameShorted,
          'image': model.get('image'),
        }
      },

      render: function () {
        var self = this;
        var allItemData = [] ,allDealType=[] ;
        this.collection.models.forEach(function (model) {
          var view = new takhfifan.GroupedExtBuyButtonView({model: model});
          view.render();
          self.$el.append(view.$el);
          allItemData.push(self.ItemDataMaker(model));
          if(!allDealType.includes(model.get('dealType'))){
            allDealType.push(model.get('dealType'));
          }
        });

        this.paginationView.$el.show();
        this.addUpdateMetaData(allItemData,allDealType);
        this.$el.parents('.tkh-dc-vendor').removeClass('loading-view');
        this.initializeOtherComponent();
      },

      renderFirstPageData: function () {
        var self = this;
        var allItemData = [], allDealType = [];
        this.$el.find('.tkh-deal-item-container').each(function () {
          var discount = new takhfifan.Discount({vendorId: self.vendorId});
          var data = $(this).data('data');
          discount.parse(data);
          self.collection.add(discount);
          var view = new takhfifan.GroupedExtBuyButtonView({el: $(this), model: discount, customView: true});
          view.render();
          allItemData.push(self.ItemDataMaker(discount));
          if (!allDealType.includes(discount.get('dealType'))) {
            allDealType.push(discount.get('dealType'));
          }
        });
        this.addUpdateMetaData(allItemData, allDealType);
        if (this.pageCount > 0) {
          this.paginationView = new takhfifan.Pagination({
            el: $('.tkh-pagination'),
            count: this.pageCount,
            currentPage: this.page,
            clickEvent: "dc:loadBrandPage",
            hideAtStart: false
          });
          this.paginationView.$el.show();
        }
        this.$el.parents('.tkh-dc-vendor').removeClass('loading-view');
        this.initializeOtherComponent();
      },

      initializeOtherComponent: function () {
        takhfifan.eventHub.trigger('dc:deal-filter-initialize');
        takhfifan.eventHub.trigger('dc:activeDealToolkit', {$deal: this.$el});
      }
    });
  });

